module.exports = __webpack_public_path__ + "img/pcbg15.085d0f0b.jpg";